    // Reset the form when the modal is closed or a new form is submitted
    function resetSizeForm() {;
      document.getElementById("form-section").style.display = "block";
      document.getElementById("info-section").style.display = "none";
    }
    
    
    function imposeMinMax(el){
      if(el.value != ""){
        if(parseInt(el.value) < parseInt(el.min)){
          el.value = el.min;
        }
        if(parseInt(el.value) > parseInt(el.max)){
          el.value = el.max;
        }
      }
    }
  
    // Function to calculate the recommended size based on user input
    function calculateRecommendedSize(recommend_lower_part) {
      // Get the values from the form
      var gender = document.getElementById("gender").value;
      var age = document.getElementById("age").value;
      var height = parseFloat(document.getElementById("height").value) / 100;
      var weight = parseFloat(document.getElementById("weight").value);
      var productType = "{{ product.type }}";
  
      // Placeholder logic for recommended size based on simple heuristics
      var recommendedSize = "";
      var smallerSizeLabel = "";
      var smallerSizeConfidence = 0;
      var biggerSizeLabel = "";
      var biggerSizeConfidence = 0;
      var doNotRecommend = false;
      var confidence;
      
      if (!recommend_lower_part) {
        var imcCustomer = (weight / (height * height)).toFixed(2);
        var imcBase = 17.5;
    
        // Apply coeffcients by Gender and Age (slope * Age + intercept)
        if (gender === '1') {  // Man
          imcBase *= (-0.00349 * age + 1.10949);
        } else {  // Woman
          imcBase *= (-0.0041 * age + 1.1738);
        }
    
        var calc = (imcCustomer - imcBase) / 4.2 * 100;
        confidence = parseInt(calc % 100);
        
        /* calc
        * <= 0: XS
        * 0 - 100: S - XS
        * 100 - 200: M - S
        * 200 - 300: L - M
        * 300 - 400: XL - L
        * 400 - 500: XXL - XL
        * 5 < : XXL
        */
        if (calc <= 0) {
          //recommendedSize = "XS";
          smallerSizeLabel = 'XS';
          smallerSizeConfidence = 100;
        } else if (calc > 0 && calc < 100) {
          smallerSizeLabel = 'XS';
          biggerSizeLabel = 'S';
        } else if (calc === 100) {
          smallerSizeLabel = 'S';
          smallerSizeConfidence = 100;
        } else if (calc > 100 && calc < 200) {
          smallerSizeLabel = 'S';
          biggerSizeLabel = 'M';
        } else if (calc === 200) {
          smallerSizeLabel = 'M';
          smallerSizeConfidence = 100;
        } else if (calc > 200 && calc < 300) {
          smallerSizeLabel = 'M';
          biggerSizeLabel = 'L';
        } else if (calc === 300) {
          smallerSizeLabel = 'L'
          smallerSizeConfidence = 100;
        } else if (calc > 300 && calc < 400) {
          smallerSizeLabel = 'L';
          biggerSizeLabel = 'XL';
        } else if (calc === 400) {
          smallerSizeLabel = 'XL';
          smallerSizeConfidence = 100;
        } else if (calc > 400 && calc < 500) {
          smallerSizeLabel = 'XL';
          biggerSizeLabel = 'XXL';
        } else if (calc >= 500 && calc < 600) {
          if (confidence <= 50) {
            smallerSizeLabel = 'XXL';
            smallerSizeConfidence = 100;
            confidence = 0;  // We ignore the previous value, since we do not have 3XL
          } else { // We do not offer 3XL
            doNotRecommend = true;
          }
        } else { // We do not offer more than XXL
            doNotRecommend = true;
        }
      } else { // The product is a lower part, like pants
        var repaCustomer = weight / (height * 100);
        var repaBase = 0.35;
        
        var calc = ((repaCustomer - repaBase) / 3 * 100).toFixed(2);
        confidence = (calc % 1).toFixed(2) * 100;

        /* calc
        * <= 0: XS
        * 0 - 1: S - XS
        * 1 - 2: M - S
        * 2 - 3: L - M
        * 3 - 4: XL - L
        * 4 - 5: XXL - XL
        * 5 < : XXL
        */
        if (calc <= 0) {
          //recommendedSize = "XS";
          smallerSizeLabel = 'XS';
          smallerSizeConfidence = 100;
        } else if (calc > 0 && calc < 1) {
          smallerSizeLabel = 'XS';
          biggerSizeLabel = 'S';
        } else if (calc === 1) {
          smallerSizeLabel = 'S';
          smallerSizeConfidence = 100;
        } else if (calc > 1 && calc < 2) {
          smallerSizeLabel = 'S';
          biggerSizeLabel = 'M';
        } else if (calc === 2) {
          smallerSizeLabel = 'M';
          smallerSizeConfidence = 100;
        } else if (calc > 2 && calc < 3) {
          smallerSizeLabel = 'M';
          biggerSizeLabel = 'L';
        } else if (calc === 3) {
          smallerSizeLabel = 'L'
          smallerSizeConfidence = 100;
        } else if (calc > 3 && calc < 4) {
          smallerSizeLabel = 'L';
          biggerSizeLabel = 'XL';
        } else if (calc === 4) {
          smallerSizeLabel = 'XL';
          smallerSizeConfidence = 100;
        } else if (calc > 4 && calc < 5) {
          smallerSizeLabel = 'XL';
          biggerSizeLabel = 'XXL';
        } else if (calc >= 5 && calc < 6) {
          if (confidence <= 50) {
            smallerSizeLabel = 'XXL';
            smallerSizeConfidence = 100;
            confidence = 0;  // We ignore the previous value, since we do not have 3XL
          } else { // We do not offer 3XL
            doNotRecommend = true;
          }
        } else { // We do not offer more than XXL
            doNotRecommend = true;
        }
      }
      
      if (doNotRecommend === false) {
        biggerSizeConfidence = confidence;
        smallerSizeConfidence = Math.min(100, 100 - biggerSizeConfidence); // Make sure we do not exceed 100 when calc < 0
    
        if (smallerSizeConfidence >= biggerSizeConfidence) {
          recommendedSize = smallerSizeLabel;
        } else {
          recommendedSize = biggerSizeLabel;
        }        
  
        // Show again the second bar in case we hid it in a previous recommendation
        document.getElementById("mySizeHeading").classList.remove("hidden");
        document.getElementById("recommendedSize").classList.remove("hidden");
        document.getElementById("SmallerSizeConfidenceBar").classList.remove("hidden");
        document.getElementById("SmallerSizeLabel").classList.remove("hidden");
        document.getElementById("SmallerSizeConfidence").classList.remove("hidden");
        document.getElementById("BiggerSizeConfidenceBar").classList.remove("hidden");
        document.getElementById("BiggerSizeLabel").classList.remove("hidden");
        document.getElementById("BiggerSizeConfidence").classList.remove("hidden");
        
        // Update modal content with results
        document.getElementById("mySizeHeading").innerText = modal_output_title;
        document.getElementById("recommendedSize").innerText = recommendedSize;
        let recommendedSizeDescription = modal_subtitle_first_part.concat(`${recommendedSize}`).concat(modal_subtitle_second_part);
        //recommendedSizeDescription += sizeAlternative ? `\nSi prefieres llevar tu prenda '${sizeAlternative}', te recomendamos la talla ${fitAlternative}`: ''
        document.getElementById("recommendedSizeDescription").innerText = recommendedSizeDescription;
        
        document.getElementById("SmallerSizeLabel").innerText = smallerSizeLabel;
        document.getElementById("SmallerSizeConfidence").innerText = `${smallerSizeConfidence}%`;
  
        // Add the arrow over the bar, just a visual decoration
        const styleSheet = document.styleSheets[0];
        styleSheet.insertRule(`#SmallerSizeConfidenceBar::after { left: ${smallerSizeConfidence}%; }`, styleSheet.cssRules.length);
        
        // If we are not recommending a bigger size
        if (biggerSizeLabel !== "") {
          document.getElementById("BiggerSizeLabel").innerText = biggerSizeLabel;
          document.getElementById("BiggerSizeConfidence").innerText = `${biggerSizeConfidence}%`;
  
          // Add the arrow over the bar, just a visual decoration
          const styleSheet = document.styleSheets[0];
          styleSheet.insertRule(`#BiggerSizeConfidenceBar::after { left: ${biggerSizeConfidence}%; }`, styleSheet.cssRules.length);
        } else { // If we are recommending one size
          // Hide the second bar, since we are recommending one size
          document.getElementById("BiggerSizeConfidenceBar").classList.add("hidden");
          document.getElementById("BiggerSizeLabel").classList.add("hidden");
          document.getElementById("BiggerSizeConfidence").classList.add("hidden");
        }
        
        // Show the result and hide the form
        document.getElementById("info-section").style.display = "block";
        document.getElementById("form-section").style.display = "none";
      } else {     
        document.getElementById("recommendedSizeDescription").innerText = 'Lamentablemente, en este momento no contamos con la talla adecuada. Sin embargo, estaremos encantados de estudiar la posibilidad de fabricarla especialmente para ti. No dudes en ponerte en contacto con nosotros a través de contact@greenerwear.eu';
        document.getElementById("mySizeHeading").classList.add("hidden");
        document.getElementById("recommendedSize").classList.add("hidden");
        document.getElementById("SmallerSizeConfidenceBar").classList.add("hidden");
        document.getElementById("SmallerSizeLabel").classList.add("hidden");
        document.getElementById("SmallerSizeConfidence").classList.add("hidden");
        document.getElementById("BiggerSizeConfidenceBar").classList.add("hidden");
        document.getElementById("BiggerSizeLabel").classList.add("hidden");
        document.getElementById("BiggerSizeConfidence").classList.add("hidden");
      }
      document.getElementById("info-section").style.display = "block";
      document.getElementById("form-section").style.display = "none";
    }
  